<script lang="ts">
	import Card from '@smui/card';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import IndirizzoDipendente from '../../../../shared/models/Dipendente/IndirizzoDipendente';
	import Sede from '../../../../shared/models/Sede/Sede';
	import { userSession } from '../../../../shared/stores';
	import { isNumeric } from '../../../../shared/validators';
	import FieldLoading from './../../../..//shared/components/common/Loading/FieldLoading.svelte';

	export let params = {
		id: '0',
	};

	let [data, loading, error] = IndirizzoDipendente.get(params.id);
	let [dataSedi, loadingSedi, errorSedi] = Sede.getList({ areaId: $userSession?.areaId, aziendaEnteId: $userSession?.aziendaEnteId });

	$: selectedSede = $dataSedi?.response?.find((x) => x?.id === $data?.sedeId);

	function onSubmit() {
		[data, loading, error] = IndirizzoDipendente.save($data);
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.employee.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<button type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="md:grid-cols-3 grid grid-cols-1">
			<Input label="{$_('page.employee.detail.province')}" bind:value="{$data.provincia}" class="md:col-start-2" />
			<Input label="{$_('page.employee.detail.city')}" bind:value="{$data.citta}" class="md:col-start-2" />
			<Input
				label="{$_('page.employee.detail.postal_code')}"
				bind:value="{$data.cap}"
				input$maxlength="{5}"
				on:keypress="{isNumeric}"
				class="md:col-start-2"
			/>
			<Input label="{$_('page.employee.detail.address')}" bind:value="{$data.indirizzo}" class="md:col-start-2">
				<svelte:fragment slot="trailingIcon">
					{#if $data.id > 0}
						{#if $data.provincia && $data.citta && $data.cap && $data.indirizzoOK}
							<span title="{$_('page.employee.detail.valid_address')}" class="material-icons-outlined" style="color: green"
								>fmd_good</span
							>
						{:else}
							<span title="{$_('page.employee.detail.not_valid_address')}" class="material-icons-outlined" style="color: red"
								>wrong_location</span
							>
						{/if}
					{/if}
				</svelte:fragment>
			</Input>
			{#if $loadingSedi}
				<FieldLoading customClass="md:col-start-2" />
			{:else}
				<Select
					label="{$_('page.pscl.detail.location')}"
					key="{(sede) => `${(sede && sede.id) || ''}`}"
					bind:value="{selectedSede}"
					class="md:col-start-2"
				>
					{#if $dataSedi?.response}
						{#each $dataSedi.response as sede (sede.id)}
							{#if sede.denominazione}
								<Option
									on:click="{() => {
										$data.sedeId = sede.id;
										$data.sede = sede.denominazione;
									}}"
									value="{sede}">{sede.denominazione}</Option
								>
							{/if}
						{/each}
					{/if}
				</Select>
			{/if}
		</form>
	{/if}
</Card>
